export default __webpack_public_path__ + "static/media/trophy-new.8a6e528a.png";